import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import cln1 from '../assets/banner4.jpg';
import cln2 from '../assets/banner3.jpg';
import cln3 from '../assets/banner6.jpg';
import cln4 from '../assets/banner4.jpg';

import {
  IoMdCheckmarkCircleOutline,
  IoMdDocument,
  IoMdBriefcase,
  IoMdRedo,
  IoMdArrowDropright
} from "react-icons/io";

export default function View(props) {

	const appContext = useContext(AppContext);

	const [ready, setReady] = useState(false);
	const [bgIndex, setBgIndex] = useState(0);
	const banners = [banner4, banner2, banner6, banner1, banner5, banner3];

	async function init() {
		setReady(false);
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 3000);

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<>
				{/* ================= HERO ================= */}
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "420px",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.8s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}

						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(110deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.75) 45%, rgba(0,0,0,0.35) 100%)",
								position: "relative",
								zIndex: 1,
								display: "flex",
								alignItems: "center"
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-7">

										<h1
											className="text-light"
											style={{
												fontSize: "42px",
												fontWeight: "700",
												letterSpacing: "1px"
											}}
										>
											Legal Services
										</h1>

										<p
											className="text-light mt-3"
											style={{
												fontSize: "18px",
												opacity: 0.85,
												lineHeight: "1.8"
											}}
										>
											Comprehensive legal advisory, structured compliance,
											and strategic representation designed to safeguard
											your organization and its interests.
										</p>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* ================= INTRO ================= */}
				<div
					style={{
						background: "linear-gradient(to bottom, #0f0f0f 0%, #161616 100%)",
						padding: "80px 0"
					}}
				>
					<div className="container text-light text-center">

						<h2 style={{ fontWeight: 600 }}>
							Clarity in Law. Strength in Protection.
						</h2>

						<p style={{ maxWidth: "760px", margin: "20px auto", opacity: 0.8 }}>
							Nassa Consult provides integrated legal services that combine
							regulatory expertise, structured documentation, and strategic
							representation. We work closely with clients to mitigate risk,
							ensure compliance, and protect long-term interests.
						</p>

						<HorizontalImageStrip
							images={[cln1, cln2, cln3, cln4]}
						/>

						<button
							className="btn btn-light btn-padded mt-5"
							onClick={()=>appContext.navTo({item:'contact_us'})}
						>
							Request Quote <IoMdArrowDropright size={32} />
						</button>

					</div>
				</div>

				{/* ================= SERVICES ================= */}
				<div
					style={{
						background: "#121212",
						padding: "90px 0"
					}}
				>
					<div className="container text-light">

						<div className="row">

							<div className="col-md-4 mb-4">
								<div style={cardStyle}>
									<IoMdDocument size={38} className="border p-2 rounded" style={{background:"rgba(255,255,255,.1"}}/>
									<h5 className="mt-3 font-bold">Contracts Drafting</h5>
									<p>
										Preparation, review, and negotiation of commercial
										agreements to ensure enforceability and clarity.
									</p>
								</div>
							</div>

							<div className="col-md-4 mb-4">
								<div style={cardStyle}>
									<IoMdRedo size={38} className="border p-2 rounded" style={{background:"rgba(255,255,255,.1"}}/>
									<h5 className="mt-3 font-bold">Dispute Resolution</h5>
									<p>
										Alternative dispute resolution, mediation,
										and structured legal representation.
									</p>
								</div>
							</div>

							<div className="col-md-4 mb-4">
								<div style={cardStyle}>
									<IoMdBriefcase size={38} className="border p-2 rounded" style={{background:"rgba(255,255,255,.1"}}/>
									<h5 className="mt-3 font-bold">Corporate Legal Advisory</h5>
									<p>
										Corporate governance advisory, regulatory compliance,
										and legal opinions for strategic decisions.
									</p>
								</div>
							</div>

						</div>
					</div>
				</div>

				{/* ================= APPROACH ================= */}
				<div
					style={{
						background: "linear-gradient(to right, #111 0%, #1a1a1a 100%)",
						padding: "90px 0"
					}}
				>
					<div className="container text-light text-center">

						<h3 style={{ marginBottom: "50px", fontWeight: 600 }}>
							Our Legal Approach
						</h3>

						<div className="row">

							<div className="col-md-4 mb-4">
								<div style={approachStyle}>
									<IoMdCheckmarkCircleOutline size={28} />
									<h6 className="mt-3 font-bold">Review</h6>
									<p>
										Comprehensive legal risk assessment and
										regulatory analysis.
									</p>
								</div>
							</div>

							<div className="col-md-4 mb-4">
								<div style={approachStyle}>
									<IoMdCheckmarkCircleOutline size={28} />
									<h6 className="mt-3 font-bold">Structure</h6>
									<p>
										Drafting legally sound frameworks and
										contractual safeguards.
									</p>
								</div>
							</div>

							<div className="col-md-4 mb-4">
								<div style={approachStyle}>
									<IoMdCheckmarkCircleOutline size={28} />
									<h6 className="mt-3 font-bold">Represent</h6>
									<p>
										Ongoing advisory support and professional
										representation where required.
									</p>
								</div>
							</div>

						</div>
					</div>
				</div>

				<Footer />
			</>
		)
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}

/* ================= STYLES ================= */

const cardStyle = {
	background: "rgba(255,255,255,0.04)",
	padding: "40px",
	borderRadius: "12px",
	backdropFilter: "blur(10px)",
	border: "1px solid rgba(255,255,255,0.08)",
	transition: "all 0.3s ease",
	minHeight: "260px"
};

const approachStyle = {
	background: "rgba(255,255,255,0.03)",
	padding: "35px",
	borderRadius: "10px",
	border: "1px solid rgba(255,255,255,0.07)",
	minHeight: "200px"
};
